// Post date, for the card mastheads on the Posts grid and the Reports review
// queue, and for the detail panel. The page is browsed a week at a time and
// staff talk about "Tuesday's session", so the weekday leads and the clock
// time trails.
export const postStamp = (iso: string) => {
  const d = new Date(iso);
  return {
    day: d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }),
    // The panel is the record itself, so it spells the date out in full.
    dayFull: d.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }),
    time: d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false }),
  };
};

export const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).replace(',', ''); 
  };

  export const formatDateWithDay = (dateString: string) => {
    const date = new Date(dateString);

    const parts = new Intl.DateTimeFormat('en-GB', {
      weekday: 'long',
      month: 'short',
      day: '2-digit',
      year: 'numeric'
    }).formatToParts(date);

    // Extract individual parts
    const weekday = parts.find(p => p.type === 'weekday')?.value;
    const day = parts.find(p => p.type === 'day')?.value;
    let month = parts.find(p => p.type === 'month')?.value || '';
    const year = parts.find(p => p.type === 'year')?.value;

    // Force month to 3 letters (e.g., "Sept" -> "Sep")
    month = month.slice(0, 3);

    // Add commas where you want them
    return `${weekday}, ${month} ${day}, ${year}`;
  };

  export const formatDateFullWithOrdinal = (
  dateString: string | Date,
  includeWeekday: boolean = true,
  includeYear: boolean = true
): string => {
  const date = new Date(dateString);

  const parts = new Intl.DateTimeFormat('en-GB', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  }).formatToParts(date);

  const weekday = parts.find(p => p.type === 'weekday')?.value;
  const day = parseInt(parts.find(p => p.type === 'day')?.value || '0', 10);
  const month = parts.find(p => p.type === 'month')?.value;
  const year = parts.find(p => p.type === 'year')?.value;

  // Ordinal helper
  const ordinal = (n: number) => {
    if (n > 3 && n < 21) return 'th';
    switch (n % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  };

  // Build parts dynamically
  let formatted = '';

  if (includeWeekday && weekday) {
    formatted += `${weekday} `;
  }

  formatted += `${day}${ordinal(day)} ${month}`;

  if (includeYear && year) {
    formatted += ` ${year}`;
  }

  return formatted.trim();
};

